import React from 'react';
import EmployeeReviewProjectGraph from './EmployeeReviewProjectGraph';
import EmployeeReviewHourGraph from './EmployeeReviewHourGraph';



const EmployeeReviewGraph = () => {



    return (
        <>
            {/* <div style={{ width: '100%', height: '450px' }}>
                <ResponsiveContainer>
                    <PieChart>
                        <Pie
                            data={data}
                            cx="50%"
                            cy="50%"
                            innerRadius="30%"
                            outerRadius="70%"
                            dataKey="value"
                            startAngle={90}
                            endAngle={-270}
                            label={renderCustomLabel}
                            labelLine={false}
                        >
                            {data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip
                            contentStyle={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #ccc' }}
                            formatter={(value, name) => [`${value}`, `${name}`]}
                        />

                    </PieChart>
                </ResponsiveContainer>
            </div> */}
            <div className='flex gap-4 w-full  pt-5'>
                < EmployeeReviewProjectGraph className="border-gray-400 w-1/2 rounded-md" />
                <EmployeeReviewHourGraph className="border-gray-400 w-1/2 rounded-md"/>
            </div>
        </>
    )
}

export default EmployeeReviewGraph